import { useAppSelector } from "../../redux/store/hooks"
import { selectSelectedDataPoint } from "../../redux/ProfessionalDashboard"
import Card from "../Card"
import SmallHeadingComponent from "../SmallHeadingComponent"

function DataPointNotesPanel() {
    const entry = useAppSelector(selectSelectedDataPoint)

    // Only show once a data point is selected and it actually has a note,
    // mirroring the questionnaire/mood detail panels.
    if (!entry || !entry.note || !entry.note.trim()) return null

    return (
        <Card>
            <SmallHeadingComponent>Notiz</SmallHeadingComponent>
            <p className="text-xs text-gray-500 mt-2">
                {new Date(entry.date).toLocaleDateString("de")}
            </p>
            <div className="mt-2 rounded-md bg-gray-50 border border-gray-200 px-3 py-2">
                <p className="text-sm text-gray-700 whitespace-pre-wrap">
                    {entry.note}
                </p>
            </div>
        </Card>
    )
}

export default DataPointNotesPanel
